import { c as _c } from "react/compiler-runtime";
import { type FC } from 'react';
import { ModalContent } from '@components/modal/ModalContent';
import { Button, Flex, Text } from '@endurancewarranty/ui';
export type Props = {
  description: string;
  onClose: () => void;
};
export const UnmappedValidationErrorModal: FC<Props> = t0 => {
  const $ = _c(8);
  const {
    description,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="mb-2"><Text.Header fontWeight="medium">Unable to Save</Text.Header></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onClose) {
    t2 = <Flex justify="end" className="mt-4 gap-2"><Button name="confirm-validation-error" variant="primary" width="fit" onClick={onClose}>Ok</Button></Flex>;
    $[1] = onClose;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <Text.Body align="left">{description}</Text.Body>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <ModalContent header={t1} footer={t2}>{t3}</ModalContent>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};